import { useEffect, useState } from 'react';
import sanitizeHtml from 'sanitize-html';

/**
 * The props for sanitizing the html
 */
interface SanitizeHtmlProps {
  /**
   * The html string to sanitize and display
   */
  html: string;
}

/**
 * A component to sanitize and display html dynamically
 */
const SanitizeHtml = (props: SanitizeHtmlProps) => {
  const [cleanHtml, setCleanHtml] = useState('');
  useEffect(() => setCleanHtml(sanitizeHtml(props.html)), [props.html]);
  return <div dangerouslySetInnerHTML={{ __html: cleanHtml }} />;
};

export default SanitizeHtml;
